// src/App.js
import React from "react";
import ClipboardImageLibrary from "./ClipboardImageLibrary";

function App() {
    return (
        <div className="App">
            <ClipboardImageLibrary />
        </div>
    );
}

export default App;
